import { Language } from './Language';

type CodeType = 'de' | 'en' | 'es';

export const DefaultLanguages: { [Key in CodeType]: Readonly<Language> } = {
  de: {
    code: 'de',
    label: 'Deutsch',
    href: 'https://www.arbeitsagentur.de/',
  },
  en: {
    code: 'en',
    label: 'English',
    href: 'https://www.arbeitsagentur.de/en/',
  },
  es: {
    code: 'es',
    label: 'Español',
    href: 'https://www.arbeitsagentur.de/es/',
  },
};
